import React, { useCallback } from "react";
import { FieldProps } from "react-jsonschema-form";
import { WitLabel } from "./common";
import { defineMessages, useIntl } from "react-intl";
//@ts-ignore
import DatePicker from "react-datepicker";
import moment from "moment";

const messages = defineMessages({
  enterDate: {
    id: "default.enterDate",
    description: "enterDate",
    defaultMessage: "enterDate",
  },
});

export function DatePickerWidget({
  formData,
  rawErrors,
  onChange,
  disabled,
  id,
  schema,
}: FieldProps) {
  const intl = useIntl();

  const handleChange = useCallback(
    formData => {
      const date = moment(formData).format("YYYY-MM-DDThh:mm:ssZ");
      onChange(date);
    },
    [onChange]
  );

  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      <DatePicker
        selected={formData && new Date(formData.substring(0, 10))}
        dateFormat={"yyyy-MM-dd"}
        placeholderText={intl.formatMessage(messages.enterDate)}
        disabled={disabled}
        className={`form-control ${rawErrors && "parsley-error"}`}
        onChange={handleChange}
        monthsShown={3}
        isClearable
      />
    </>
  );
}
